import { gql } from '@apollo/client';

export const QUERY_QUOTE_PAGE = gql`
  query quotePage {
    quotePage {
      data {
        attributes {
          quoteOfTheDayTitle
          cta {
            text
            link
          }
        }
      }
    }
  }
`;

export const QUERY_CURRENT_QUOTE = gql`
  query quote($date: DateFilterInput) {
    quotes(filters: { date: $date }) {
      data {
        id
        attributes {
          quote
          author
          topic {
            data {
              attributes {
                topic
              }
            }
          }
          date
          occupation
          quoteWithLinks
          links {
            podcast {
              data {
                attributes {
                  slug
                }
              }
            }
            mindfulExercise {
              data {
                attributes {
                  slug
                }
              }
            }
            course {
              data {
                attributes {
                  slug
                }
              }
            }
            resource {
              data {
                attributes {
                  slug
                }
              }
            }
            redirectToCurrentInsight
            redirectToCurrentMindfulMinute
            redirectToCalendar
            redirectToEmotionWheel
          }
        }
      }
    }
  }
`;
